import { FormItem, NumberInput } from '@framework/form';
import React from 'react';

export interface IBaseLayoutColSpanInputProps {
  isTableColumn: boolean;
}
/**
 * Input di configurazione per la larghezza in colonne del widget
 * valido quando è posizionato in un elemento di tipo Riga.
 */
export function BaseLayoutColSpanInput(props: IBaseLayoutColSpanInputProps) {
  const { isTableColumn } = props;

  return isTableColumn ? (
    <FormItem name="layout.tableColumnWidth" label="Larghezza colonna">
      <NumberInput name="layout.tableColumnWidth" addonAfter="%" />
    </FormItem>
  ) : (
    <FormItem
      name="layout.colSpan"
      label="Numero Colonne"
      help="Se posizionato in un elemento di tipo Riga"
    >
      <NumberInput name="layout.colSpan" />
    </FormItem>
  );
}
